import CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy from './CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy'

export default function CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy() {}

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype = new CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy();

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype.init = function({timeFormat, showAverageRates, showOthers}) {
    CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.init.call(
        this,
        {
            timeFormat: timeFormat,
            showAverageRates: showAverageRates,
            showOthers: showOthers,
        }
    )
    return this
}

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype.getLevelNameKey = function ()
{
    return "report.user";
};

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype.getLevelCellsClassName = function ()
{
    return "lightGreenHeaderCell";
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.js